import GeoJSON from 'ol/format/GeoJSON';
import { fromCircle } from 'ol/geom/Polygon';
import { CIRCLE } from 'client/utils/constants/geometryType';

export const getGeoJsonGeometry = (map, layerId) => {
    let geometry = map?.getLayerById(layerId)?.getSource()?.getFeatures()[0]?.getGeometry();
    if (!geometry) {
        return false;
    }
    if (geometry.getType() === CIRCLE) {
        geometry = fromCircle(geometry, 60);
    }
    return JSON.stringify(getGeoJsonFromGeometry(geometry));
};

export const getGeoJsonFromGeometry = (geometry) => {
    if (geometry) {
        const reader = new GeoJSON();
        return reader.writeGeometryObject(geometry);
    } else {
        return null;
    }
};
